import { ACADEMY_SUPPORTED_LANGUAGES } from 'academy-common-lib/constants/academySupportedLanguages';
export const convertToAcademyLanguage = lang => {
  const upperLang = typeof lang === 'string' ? lang.toUpperCase() : 'EN';
  return ACADEMY_SUPPORTED_LANGUAGES.includes(upperLang) ? upperLang : 'EN';
};
export const getLanguagesFromLinkedContent = (languageMap, currentLanguage) => {
  const languages = Object.keys(languageMap !== null && languageMap !== void 0 ? languageMap : {});
  if (!languages.length) {
    return [];
  }
  if (!languages.includes(currentLanguage.toUpperCase())) {
    languages.push(currentLanguage.toUpperCase());
  }
  languages.sort();
  return languages;
};